"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Unhappy = function Unhappy(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 96 96"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("title", null, 'Icons/Unhappy'), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M48.013 78.026c-16.569 0-30-13.431-30-30 0-16.569 13.431-30 30-30 16.568 0 30 13.431 30 30 0 16.569-13.432 30-30 30zm-10-40c-3.341 0-5 3.893-5 7.5 0 1.642.213 2.5.937 2.5 1.493 0 2.076-1.25 4.063-1.25 1.986 0 2.569 1.25 4.062 1.25.724 0 .938-.858.938-2.5 0-3.607-1.659-7.5-5-7.5zm20 0c-3.341 0-5 3.893-5 7.5 0 1.642.213 2.5.937 2.5 1.493 0 2.076-1.25 4.063-1.25 1.986 0 2.568 1.25 4.062 1.25.724 0 .938-.858.938-2.5 0-3.607-1.659-7.5-5-7.5zM33.95 65.524c1.734 0 5.153-5 14.063-5 8.909 0 12.328 5 14.062 5a.875.875 0 00.938-.938c0-1.614-5.624-9.062-15-9.062-9.377 0-15 7.447-15 9.062a.875.875 0 00.937.938z",
    id: "Unhappy_svg__a"
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("mask", {
    id: "Unhappy_svg__b",
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#Unhappy_svg__a"
  })), (0, _core.jsx)("g", {
    mask: "url(#Unhappy_svg__b)",
    fill: "currentColor"
  }, (0, _core.jsx)("path", {
    d: "M0 0h96v96H0z"
  }))));
};

var _default = (0, _react.forwardRef)(Unhappy);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Unhappy, "Unhappy", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Unhappy.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Unhappy.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();